import { getColumnClasses } from "@/lib/viewportMapper";
import { BasicComponent } from "@/modules/ComponentMap/types";
import { Input } from "./Input";

export const Textarea = (props) => <Input {...props} as="textarea" rows="7" />;

export const Typo3Textarea = ({
  identifier,
  label,
  name,
  validators,
  properties = {},
  disabled = false,
}: BasicComponent<any> & {
  identifier: string;
  label: string;
  name: string;
  validators?: { identifier: string }[];
  as: "input" | "select" | "textarea";
  disabled?: boolean;
}) => {
  const { gridColumnClassAutoConfiguration = {}, elementClassAttribute } =
    properties;
  const { viewPorts } = gridColumnClassAutoConfiguration;

  return (
    <div
      className={`${
        viewPorts && getColumnClasses(viewPorts)
      } ${elementClassAttribute} mb-4`}
    >
      <Textarea
        identifier={identifier}
        label={label}
        validators={validators}
        disabled={disabled}
        name={name}
      />
    </div>
  );
};
